import React from 'react';
import { toast } from 'react-toastify';
import EventBus from "../common/EventBus";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false,
            errorType: null
        };
    }

    static getDerivedStateFromError(error) {
        let errorType = 'unknown';
        
        if (error.code === 'ECONNRESET' || 
            error.message?.includes('network') || 
            error.message?.includes('connection')) {
            errorType = 'connection';
        }
        
        return { 
            hasError: true,
            errorType
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error:', error);
        console.error('Error Info:', errorInfo);
        
        if (error.code === 'ECONNRESET' || 
            error.message?.includes('network') || 
            error.message?.includes('connection')) {
            toast.error('Connection error. Please check your internet connection and try again.', {
                position: "top-center",
                autoClose: 5000
            });
        } else {
            toast.error('Something went wrong. Please refresh the page.', {
                position: "top-center",
                autoClose: 5000
            });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-container text-center p-5">
                    <h2>
                        {this.state.errorType === 'connection' 
                            ? 'Connection Error' 
                            : 'Something went wrong'}
                    </h2>
                    <p className="mb-4">
                        {this.state.errorType === 'connection'
                            ? 'There was a problem with your internet connection. Please check your connection and try again.'
                            : 'An unexpected error occurred. Please try refreshing the page.'}
                    </p>
                    <button 
                        className="btn btn-primary me-3"
                        onClick={() => window.location.reload()}
                    >
                        Refresh Page
                    </button>
                    {this.state.errorType === 'connection' && (
                        <button 
                            className="btn btn-outline-primary"
                            onClick={() => {
                                // Try to reconnect or retry the last operation
                                this.setState({ hasError: false, errorType: null });
                            }}
                        >
                            Try Again
                        </button>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 